<template>
  <div>
    <div class="row">
      <div class="col-sm-6 col-xs-12">
        <div class="form-group">
          <label for="ShowDiscount"
            >Are you a Senior or Access pass holder?
            <span class="text-danger"
              >*
              <span class="sr-only">Required</span>
            </span>
          </label>
          <select v-model="showDiscount" class="form-control" id="ShowDiscount">
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </div>
      </div>
    </div>
    <template v-if="showDiscount === 'true'">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="DiscountPassNumber"
              >Senior pass holders and Access pass holders are eligible for a
              50% discount. Enter your pass number:</label
            >
            <input
              class="form-control"
              :value="discountPassNumber"
              id="DiscountPassNumber"
              @change="
                $emit('change', {
                  name: 'discountPassNumber',
                  value: $event.target.value
                })
              "
              :class="errorClass"
            />
            <small
              >* Only Senior or Access passes issued under the America the
              Beautiful the National Parks and Federal Recreational Lands Pass
              program are eligible for discounts. You must bring and present
              your pass upon request. Reservations made with invalid passes will
              be required to pay the difference.</small
            >
            <br />
            <span class="field-validation-error" v-if="this.error">{{
              error
            }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["error", "discountPassNumber"],
  data() {
    return {
      showDiscount: "false"
    };
  },
  computed: {
    errorClass() {
      if (this.error) {
        return "input-validation-error";
      }
      return "";
    }
  }
};
</script>
